import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"

export const useUpdateDiscount = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateDiscountAvailable(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Акции изменены')
    },
  })

	return mutation
}